import * as React from "react";

import { SliderState } from ".";
import { SliderContext } from "./Slider";

type CurrentIndexProps = {
};
type Props = CurrentIndexProps;

const CurrentIndex: React.SFC<Props> = () => {
    return (
        <SliderContext.Consumer>
            {(context: SliderState) => (
                <React.Fragment>
                    {context.index + 1}
                </React.Fragment>)}
        </SliderContext.Consumer>
    );
};

export default CurrentIndex;


// WEBPACK FOOTER //
// ./src/components/Slider/CurrentIndex.tsx